import { Skeleton } from '@mantine/core'

export function TableLoader () {
	return (
		<Skeleton height={20} mt={6} width="50%" />
	)
}
